(function() {
    'use strict';

    angular
        .module('app.centrosCostoTercerNivel')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/centros-costo-tercer-nivel',
                config: {
                    templateUrl: 'app/centrosCostoTercerNivel/centrosCostoTercerNivel.html',
                    controller: 'CentrosCostoTercerNivel',
                    controllerAs: 'vm',
                    title: 'CentrosCostoTercerNivel'
                }
            },
            {
                url: '/editar-centro-costo-tercer-nivel/:id?',
                config: {
                    templateUrl: 'app/centrosCostoTercerNivel/editarCentroCostoTercerNivel.html',
                    controller: 'EditarCentroCostoTercerNivel',
                    controllerAs: 'vm',
                    title: 'EditarCentroCostoTercerNivel'
                }
            }
        ];
    }
})();
